// @core/api/endpoints/workflow/get_prompt_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PromptTemplateResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get prompt template
 * Retrieves a prompt template with its variables and settings.
 */
export async function GetPromptTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<PromptTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/prompt-templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.get<PromptTemplateResponse>(requestPath, { ...requestOptions });
}
